import { render, staticRenderFns } from "./payCryptoRouter.vue?vue&type=template&id=64b62a9c"
import script from "./payCryptoRouter.vue?vue&type=script&lang=js"
export * from "./payCryptoRouter.vue?vue&type=script&lang=js"
import style0 from "./payCryptoRouter.vue?vue&type=style&index=0&id=64b62a9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports